var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-mission"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('join.mission')))]),_c('h2',[_vm._v(_vm._s(_vm.$t('join.missionText')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }